import React, { Component } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import ReactTable from 'react-table'
import { API_URL } from '../constants'
import { PageWrapper, FlexWrapper, XMText, Button } from '../components'
import 'react-table/react-table.css'
import { get } from 'lodash'
import { createGlobalStyle } from 'styled-components'
import moment from 'moment'
import FileDownload from 'js-file-download'

const GlobalStyle = createGlobalStyle`
  body>div{
    max-width:100% !important;
  }
`

const TableWrap = styled.div`
  position: relative;
  .ReactTable.-striped.-highlight {
    padding-bottom: 50px;
  }
  .rt-thead.-header {
    background: #078489;
    color: #fff;
  }
  .rt-td {
    white-space: normal !important;
  }
  .pagination-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #078489;
    color: #fff;
  }
  .ReactTable .-pagination .-btn[disabled] {
    color: #fff;
    opacity: 0.9;
  }
  .ReactTable .-pagination .-btn {
    color: #fff;
  }
  .rt-tbody {
    /* max-height: calc(100vh - 93px); */
  }

  .ReactTable .rt-thead.-filters .rt-th:nth-child(9) > input {
    display: block !important;
  }
  .ReactTable .rt-thead.-filters .rt-th:nth-child(n + 2) > input {
    display: none;
  }
`
class ViewUpcCode extends Component {
  state = {
    loader: false,
    upcData: [],
    checkedRows: [],
    checkAll: false,
    changeStatusModal: false,
    isSubmitLoading: false,
    selectedOption: null,
    id: null,
    showModal: false,
    selectedOptionNominate: false,
    isCsvLoading: false
  }
  componentDidMount() {
    this.getUpcCodes()
  }

  getUpcCodes = async () => {
    try {
      /*  const query = {
        filter: {
          order: ['createdAt DESC'],
          include: ['user']
        }
      }
      const { data } = await axios.get(`${API_URL}/UpcTracks`, {
        params: { filter: query.filter }
      }) */

      const { data } = await axios.post(`${API_URL}/UpcTracks/getUpc`, {
        csv: 'false'
      })

      this.setState({ upcData: data })
    } catch (error) {
      console.log(error)
    }
  }

  handleCsv = async () => {
    this.setState({ isCsvLoading: true })
    try {
      const { data } = await axios.post(`${API_URL}/UpcTracks/getUpc`, {
        csv: 'true'
      })
      FileDownload(data, 'upcTrack.csv')
      this.setState({ isCsvLoading: false })
    } catch (error) {
      console.log(error)
      this.setState({ isCsvLoading: false })
    }
  }

  updateUpcCode = id => {
    this.setState({ id, showModal: true })
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption: selectedOption })
  }

  handleChangeNominate = selectedOptionNominate => {
    this.setState({ selectedOptionNominate: selectedOptionNominate })
  }

  render() {
    const { upcData, isCsvLoading } = this.state
    return (
      <React.Fragment>
        <GlobalStyle />
        <PageWrapper viewPadding="0 20px" height="auto" modifyPadding="0 20px">
          <TableWrap>
            <ReactTable
              data={upcData}
              filterable={true}
              sortable={false}
              defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
              columns={[
                {
                  // Header: 'ID',
                  Header: row => {
                    return (
                      <React.Fragment>
                        <div>ID</div>
                        <Button
                          style={{
                            border: '1px solid #fff',
                            borderRadius: 4,
                            padding: 2,
                            marginTop: 1,
                            height: 22,
                            fontSize: 11
                          }}
                          size="small"
                          label="Export Csv"
                          isLoading={isCsvLoading}
                          disabled={isCsvLoading}
                          onClick={this.handleCsv}
                        />
                      </React.Fragment>
                    )
                  },
                  accessor: 'id',
                  width: 150
                },
                {
                  Header: 'Date',
                  accessor: 'createdAt',
                  Cell: row =>
                    row.original.createdAt
                      ? moment(get(row.original, 'createdAt', '')).format('MMMM Do YYYY, h:mm:ss a')
                      : '',
                  width: 180
                },
                {
                  Header: 'UserId',
                  accessor: 'userId',
                  width: 70
                },
                {
                  Header: 'User Email',
                  Cell: row => get(row.original, 'email', ''),
                  width: 250
                },
                {
                  Header: 'Upc Code',
                  accessor: 'upcScanned',
                  width: 250
                },
                {
                  Header: row => {
                    return (
                      <React.Fragment>
                        <div>Current Status</div>
                      </React.Fragment>
                    )
                  },
                  accessor: 'isCorrect',
                  Cell: row => (get(row, 'original.isCorrect', false) ? 'Updated' : 'Not Updated'),
                  filterMethod: (filter, row) => {
                    if (filter.value === 'all') {
                      return true
                    }
                    if (filter.value === 'Updated') {
                      return row[filter.id] === true
                    }
                    return row[filter.id] === false
                  },
                  Filter: ({ filter, onChange }) => (
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{ width: '100%' }}
                      value={filter ? filter.value : 'all'}>
                      <option value="all">All</option>
                      <option value="Updated">Updated</option>
                      <option value="Not Updated">Not Updated</option>
                    </select>
                  ),
                  width: 300
                },
                {
                  Header: (
                    <FlexWrapper alignItems="center">
                      <XMText color="#fff">Action</XMText>
                    </FlexWrapper>
                  ),
                  Cell: row => (
                    <React.Fragment>
                      <span
                        style={{ color: '#124b5f', textDecoration: 'underline' }}
                        onClick={() =>
                          this.props.history.push({
                            pathname: `/add-upccode-native/${get(row.original, 'id', '')}`,
                            state: {
                              userId: get(row.original, 'userId', ''),
                              userEmail: get(row.original, 'email', ''),
                              upcScanned: get(row.original, 'upcScanned', '')
                            }
                          })
                        }>
                        {' '}
                        Add upcCode
                      </span>
                    </React.Fragment>
                  ),
                  width: 150
                }
              ]}
              defaultPageSize={50}
              // pageSize={5}
              minRows={0}
              resizable={false}
              className="-striped -highlight"
            />
          </TableWrap>
        </PageWrapper>
      </React.Fragment>
    )
  }
}
export default ViewUpcCode



// WEBPACK FOOTER //
// ./src/pages/ViewUpcCode.js